import React from 'react';

import dayjs from '~/timeInit';

import { Chip, Stack, Tooltip } from '@mui/material';

import type { CompetitorProperty } from '~/types/services/priceParrot';

import { formatDate } from './utils';

interface Props {
  property: CompetitorProperty;
}

export default function CompetitorOfferStatusChips({ property }: Props) {
  const lastCollected = property.lastCollectedAt
    ? `Last collected ${dayjs(property.lastCollectedAt).fromNow()}`
    : 'Never collected';
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {property.inLatestCollection ? (
        <Tooltip title={formatDate(property.lastCollectedAt)}>
          <Chip size="small" color="success" label={lastCollected} />
        </Tooltip>
      ) : (
        <Tooltip title={formatDate(property.lastCollectedAt)}>
          <Chip size="small" label={`${lastCollected} · not in latest collection`} />
        </Tooltip>
      )}
    </Stack>
  );
}
